<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_exam") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_ar')"
            v-model.trim="data.instructions_ar"
            required
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_en')"
            v-model.trim="data.instructions_en"
            required
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.min_exam_pass_score')"
            v-model.trim="data.minimum_passing_score"
            required
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.exam_duration')"
            v-model.trim="data.duration"
            required
            disabled
          />
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              disabled
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>

          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "ShowBank",
  components: { FileUpload },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      data: {
        name_ar: null,
        name_en: null,
        instructions_en: null,
        instructions_ar: null,
        duration: "",

        minimum_passing_score: "",
        is_active: false,
      

},
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
    handleFileRemove(index) {
      this.preparedUrls.splice(index, 1);
    },
    async showExam() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `exams/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Exam.name_ar;
        this.data.name_en = res.data.data.Exam.name_en;

        this.data.instructions_ar = res.data.data.Exam.directions_ar;
        this.data.instructions_en = res.data.data.Exam.directions_en;
        this.data.minimum_passing_score =
          res.data.data.Exam.minimum_passing_score;
        this.data.duration = res.data.data.Exam.duration;
        this.data.is_active = res.data.data.Exam.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showExam();
  },
};
</script>
